export enum TokenStorageKey {
  AccessToken = 'AccessToken',
  RefreshToken = 'RefreshToken',
  GaAccountId = 'gaAccountId',
  GaUserId = 'gaUserId',
  ShouldRemember = 'ShouldRemember',
}
